import React, {
    ReactElement,
} from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { Loading } from "../../../../components";
import Avatar from "../../../../components/avatar/Avatar";
import DisplayUserGroup from "../../../../components/creators/user-groups/UserGroups";
import useRouting, { Link, useParams } from "../../../../contexts/Routing";
import { useGetUserGroupsQuery } from "../../../../__generated__/api";
import { ErrorRemote } from "../../../error/Error";

function DisplayList(): ReactElement {
    const { data, error, loading: isLoading } = useGetUserGroupsQuery({
        fetchPolicy: "no-cache",
    });
    const { Paths } = useRouting();

    if (isLoading) {
        return <Loading />;
    }
    if (error) {
        return <ErrorRemote error={error} />;
    }

    return (
        <div className="d-flex align-items-stretch flex-column">
            <div className="border p-3 rounded bg-white">
                {data?.userGroups.isNotEmpty ? (
                    <>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <h5 className="text-light mb-0">
                                Groups
                            </h5>

                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "new",
                                    setting: "user-groups",
                                }}
                                className="btn btn-none btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Group
                            </Link>

                        </div>
                        <div className="list-group">
                            {data?.userGroups.sortBy(group => group.name.toLowerCase()).map(group => (
                                <Link
                                    to={Paths.ADMINISTRATOR_SETTING_ID}
                                    params={{
                                        id: group.id,
                                        setting: "user-groups",
                                    }}
                                    className="list-group-item list-group-item-action flex-column align-items-start"
                                >
                                    <div className="d-flex w-100 align-items-end mb-2">
                                        <h5 className="mb-0">
                                            {group.name}
                                            {" "}
                                        </h5>
                                    </div>
                                    <small>{group.description}</small>
                                    <div className="d-flex w-100 align-items-end mt-3">
                                        {group.users.limit(5).map((user, index) => (
                                            <Avatar
                                                src={user.avatarUrl as string}
                                                isCircle
                                                variant="xs"
                                                className={index === 0 ? "" : "ms-n2"}
                                            />
                                        ))}
                                        <div className="ms-2 text-light">
                                            {group.users.length}
                                            {" "}
                                            Users
                                        </div>

                                    </div>

                                </Link>

                            ))}

                        </div>
                        <div className="d-flex justify-content-end align-items-center mt-3">

                            <Link
                                to={Paths.ADMINISTRATOR_SETTING_ID}
                                params={{
                                    id: "new",
                                    setting: "user-groups",
                                }}
                                className="btn btn-secondary btn-sm"
                            >
                                <AiOutlinePlus />
                                {" "}
                                Group
                            </Link>
                        </div>

                    </>
                ) : (
                    <div className="d-flex flex-column align-items-center justify-content-center h-100 text-light my-4">
                        <h5 className="text-light">
                            Group
                        </h5>
                        <Link
                            to={Paths.ADMINISTRATOR_SETTING_ID}
                            params={{
                                id: "new",
                                setting: "user-groups",
                            }}
                            className="btn btn-secondary btn-sm my-3"
                        >
                            <AiOutlinePlus />
                            {" "}
                            Add Group
                        </Link>
                        <small>
                            Groups allow you to set permissions to a group of people instead of individuals.
                        </small>
                    </div>

                )}

            </div>

        </div>
    );
}

export default function UserGroupSettings(): ReactElement {
    const { Paths, historyPush } = useRouting();

    const { id } = useParams(Paths.ADMINISTRATOR_SETTING_ID);
    return id ? (
        <DisplayUserGroup
            id={id}
            canDelete
            className="border p-3 rounded mb-4 bg-white"
            onDeleted={() => {
                historyPush(Paths.ADMINISTRATOR_SETTING, {
                    setting: "user-groups",
                });
            }}
            onSave={() => {
                historyPush(Paths.ADMINISTRATOR_SETTING, {
                    setting: "user-groups",
                });
            }}
        />
    ) : <DisplayList />;
}
